import 'css-chunksrc/client/common/preview/zipRenderer/nodes/node/styles.scss';export default {
  "node": "_node_1de8n_1",
  "iconBox": "_iconBox_1de8n_8",
  "icon": "_icon_1de8n_8",
  "name": "_name_1de8n_20"
};